// Generated by scripts/theme-config/theme-config.js from api::theme-configuration. Do not edit.
import type { GeneratedListingCardTheme } from './listing-card-theme';

export const generatedListingCardTheme: GeneratedListingCardTheme = {
  "titleEstiloSlug": null,
  "priceEstiloSlug": null,
  "ctaIcon": "none",
  "badgeStyle": "pill",
  "badgeText": "¡Nuevo!",
  "desc": {
    "surface": true,
    "extras": true
  },
  "cardRadiusClass": null,
  "imageRadiusClass": null
};
